import React from 'react';
import { Text, Box, Center, Button, Heading, Image } from '@chakra-ui/react';
import Bank from '@invitato/helpers/dist/constants/banks';

import { BUTTON_PADDING_PROPS, DEFAULT_BUTTON_PROPS } from '@/constants/colors';
import { ASSETS_BUTTERFLY } from '@/constants/assets';
import { TEXT_PROPS } from '@/constants/default-props';

import bcaLogo from '@/assets/icons/bca.png';

import txtWording from './locales';
import { ENABLE_SEND_GIFT } from '@/constants/feature-flags';

function ModalBank({ onCopyText, lang }) {
  const renderBank = (bank, userName, bankNumber) => {
    return (
      <Box padding="16px 0" textAlign="center" {...TEXT_PROPS.body}>
        <Center>
          <Image src={bank.logo} marginBottom="8px" maxWidth="80px" />
        </Center>
        <Text color="secondaryColorText" fontSize="20px" py="4px" fontWeight="bold">
          {bankNumber}
        </Text>
        <Text color="mainColorText" fontSize="20px" fontWeight="bold">
          {userName}
        </Text>
        <Center>
          <Button
            {...DEFAULT_BUTTON_PROPS}
            {...BUTTON_PADDING_PROPS}
            mt="16px"
            fontSize="16px"
            padding="1em 1.5em"
            onClick={() => onCopyText(bankNumber)}
          >
            {txtWording.modalCopy[lang]}
          </Button>
        </Center>
      </Box>
    );
  };

  return (
    <>
      {/* Bank Section */}
      <Box margin="24px auto 0 auto" textAlign="center" position="relative">
        <Heading {...TEXT_PROPS.heading} pos="relative">
          Bank Transfer
          <Image src={ASSETS_BUTTERFLY} className="butterfly-gift-left" />
        </Heading>
      </Box>

      <Box marginTop="8px">{renderBank({ logo: bcaLogo }, 'Invitato', '0101010101')}</Box>
      <Box marginTop="8px">{renderBank({ logo: bcaLogo }, 'Invitato 2', '0101010101')}</Box>
      {!ENABLE_SEND_GIFT && <Box h="16px" />}
    </>
  );
}

export default ModalBank;
